import React, { useState, useContext } from 'react';
import { useSwipeable } from 'react-swipeable';
import { ArrowUp, RotateCcw, ListVideo, Ellipsis } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; 
import styles from './QuestionFooter.module.scss';
import { DEBUG } from '../../utils/constants';

import useQuestionsManager from '../../utils/hooks/useQuestionsManager';
import CluesStrip from '../../utils/CluesStrip/CluesStrip';

import { useGame } from '../../context/GameContext';
import { LanguageContext } from '../../context/LanguageContext';
// Import des traductions 
import translations from '../../utils/translations/QuestionFooterTranslations';


const debug = DEBUG;

const QuestionFooter = ({type, gId, setShowIntro, setIsReplay, gIdInfos = null}) => {

    const { clearQuestions } = useQuestionsManager(type, gId);
    const { clearGameData } = useGame();

    // Utilisation du contexte de langue global
    const { language } = useContext(LanguageContext);

    // Accès simplifié aux traductions
    const t = translations[language] || translations.fr;

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showClues, setShowClues] = useState(false);
    const [showCluesModal, setShowCluesModal] = useState(false);

    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsMenuOpen(prev => !prev);
    };

    const swipeHandlers = useSwipeable({
        onSwipedUp: () => {
            if (!isMenuOpen) setIsMenuOpen(true);
        },
        onSwipedDown: () => {
            if (isMenuOpen) setIsMenuOpen(false);
        },
        preventDefaultTouchmoveEvent: true,
        trackTouch: true,
    });

    const handleConfirm = () => {

        if (debug) console.log("Type de jeu : ", type);
        if (debug) console.log("Id du parcours : ", gId);

        // Suppression de la progression en local
        if (type === "inde") {
            localStorage.removeItem(`progression_inde_${gIdInfos}`);
            localStorage.removeItem(`currentGameInfoId`);
            localStorage.removeItem(`currentGameId`);

            localStorage.removeItem(`questions_inde_${gIdInfos}`);
            localStorage.removeItem(`questions_inde_undefined`);
            localStorage.removeItem(`repLibres_inde_${gIdInfos}`);
            localStorage.removeItem(`repQcm_inde_${gIdInfos}`);

            // Langue mémorisée pour ce jeu (si utilisée auparavant)
            localStorage.removeItem(`gameLang-${gIdInfos}`);
        } else {
            localStorage.removeItem(`progression_${gId}`);
		    localStorage.removeItem(`questionsStructure_${gId}`);
        }

        clearQuestions();   // Supprime les données liées aux questions
        clearGameData();    // Supprime les infos stockées dans GameContext

        setShowModal(false);

        // Redirection en fonction du type de jeu
        navigate(type === "inde" ? '/' : '/choix-village');
    };

  return (
    <div {...swipeHandlers} className={styles.footerContainer}>
        <div
            data-testid="toggle-menu"
            className={styles.questionFooter}
            onClick={toggleMenu}
        >
           <Ellipsis /> <ArrowUp size={24} className={isMenuOpen ? styles.rotated : ''} />
        </div>

        {isMenuOpen && (
            <div className={styles.menu}>
                <button
                    className={styles.leftButton}
                    onClick={() => setShowModal(true)}
                >
                    <span>Réinitialiser la partie</span> <RotateCcw size={24} />
                </button>

                {type === "inde" && (
                    <button
                        className={styles.centerButton} // optionnel : tu peux réutiliser left/rightButton si tu préfères
                        onClick={() => {
                            setShowCluesModal(true);
                            setIsMenuOpen(false);
                        }}
                    >
                        <span>{t.cluesButton || "Voir les indices"}</span> <ArrowUp size={20} />
                    </button>
                )}

                <button 
                    className={styles.rightButton}
                    onClick={() => {
                        setShowIntro(true);
                        setIsReplay(true);
                        setIsMenuOpen(false);
                    }}
                >
                    <span>Revoir l'introduction</span> <ListVideo />
                </button>
            </div>
        )}

        {showModal && (
            <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <p>{t.confirmQuitText}</p>
                <div className={styles.modalButtons}>
                    <button className={styles.quitButton} onClick={handleConfirm}>{t.confirmButton}</button>
                    <button className={styles.resumeButton} onClick={() => setShowModal(false)}>{t.cancelButton}</button>
                </div>
            </div>
            </div>
        )}

        {showCluesModal && type === "inde" && (
            <div className={styles.modalOverlay} role="dialog" aria-modal="true" aria-label="Indices trouvés">
                <div className={`${styles.modalContent} ${styles.cluesModal}`}>
                    <div className={styles.modalHeader}>
                        <h3 className={styles.modalTitle}>Indices trouvés</h3>
                        <button
                        className={styles.closeButton}
                        onClick={() => setShowCluesModal(false)}
                        aria-label="Fermer"
                        >
                        ✕
                        </button>
                    </div>

                    {/* Le carrousel d’indices */}
                    <CluesStrip
                        gameInfoId={gIdInfos}
                        title=""
                        emptyLabel="Aucun indice pour le moment."
                    />

                    <div className={styles.modalButtons}>
                        <button className={styles.resumeButton} onClick={() => setShowCluesModal(false)}>
                        Fermer
                        </button>
                    </div>
                </div>
            </div>
        )}

    </div>
  );
};

export default QuestionFooter;
